import http from "../../utils/http";
import { permissions } from "../../utils/roles";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import {
  resetConsentState,
  setConsentLoader,
  setConsentsDetails,
  setConsentSubmitting,
  toggleConsentLoader,
} from "../reducers/consentSlice";
import { AppThunk } from "../store";

export const loadConsentDetails =
  (
    studyId: string,
    formId: string,
    versionId: string,
    type: "platform" | "study",
    builderEditable: boolean,
    previewMode?: boolean,
    formType: "consent" | "sunshine" = "consent"
  ): AppThunk =>
  async (dispatch, getState) => {
    try {
      if (!versionId || !formId || (type === "study" && !studyId)) {
        dispatch(resetConsentState());
        return;
      }

      dispatch(setConsentLoader(true));
      let data: any;
      const prefix =
        type === "platform"
          ? `/platform/admin/econsent`
          : formType === "sunshine"
          ? `/admin/study/${studyId}/sunshine`
          : `/admin/study/${studyId}/econsent`;
      data = await http.get(`${prefix}/${formId}/version/${versionId}/blocks`);

      const formStatus = data?.data?.data?.consent?.version?.status;
      const consentName = data?.data?.data?.consent?.name;

      if (data?.data && data?.data?.data) {
        const dataEditable =
          type === "platform" ? true : getState().study.dataEditable;
        const editable = previewMode
          ? false
          : formStatus === "draft" &&
            dataEditable &&
            builderEditable &&
            type === "platform"
          ? true
          : getState().study.studyPermissions.includes(
              permissions.studyDesigner
            );

        // Sort Questions
        let blocks = data?.data?.data?.blocks
          ?.slice()
          .sort(
            (a: { position: number }, b: { position: number }) =>
              a.position - b.position
          );

        dispatch(
          setConsentsDetails({
            consentName: consentName,
            error: "",
            loading: false,
            editable: editable,
            formSubmitting: false,

            formDirty: false,

            status: formStatus,

            showPropModal: false,
            modalConsent: null,
            modalIsEdit: false,

            isBasicError: "",

            blocks: blocks,
            formId: formId,
            studyId: studyId,
            versionId: versionId,
            toggleLoader: false,
            type: type,
            formType: formType,
          })
        );
      }
    } catch (err) {
      dispatch(setConsentSubmitting(false));
      dispatch(setConsentLoader(false));
      errorToastMessage(err as Error);
    }
  };

export const saveConsent =
  (isUpdate: boolean): AppThunk =>
  async (dispatch, getState) => {
    const { formId, studyId, modalConsent, versionId, type, formType } =
      getState().consent;

    const body = {
      ...modalConsent,
    };
    try {
      dispatch(setConsentLoader(true));
      dispatch(setConsentSubmitting(true));
      const prefix =
        type === "platform"
          ? `/platform/admin/econsent`
          : formType === "sunshine"
          ? `/admin/study/${studyId}/sunshine`
          : `/admin/study/${studyId}/econsent`;
      if (isUpdate) {
        const { data } = await http.patch(
          `${prefix}/${formId}/version/${versionId}/blocks/${modalConsent.id}`,
          body
        );

        toastMessage("success", data.message);
        dispatch(toggleConsentLoader());
      } else {
        const { data } = await http.post(
          `${prefix}/${formId}/version/${versionId}/blocks`,
          body
        );

        toastMessage("success", data.message);
        dispatch(toggleConsentLoader());
      }
    } catch (err) {
      dispatch(setConsentSubmitting(false));
      dispatch(setConsentLoader(false));
      errorToastMessage(err as Error);
    }
  };

export const deleteConsent =
  (id: string): AppThunk =>
  async (dispatch, getState) => {
    const { formId, studyId, versionId, type, formType } = getState().consent;

    try {
      dispatch(setConsentSubmitting(true));
      const prefix =
        type === "platform"
          ? `/platform/admin/econsent`
          : formType === "sunshine"
          ? `/admin/study/${studyId}/sunshine`
          : `/admin/study/${studyId}/econsent`;
      const { data } = await http.delete(
        `${prefix}/${formId}/version/${versionId}/blocks/${id}`
      );
      if (data) {
        toastMessage("success", data.message);
        dispatch(toggleConsentLoader());
      }
    } catch (err) {
      dispatch(setConsentSubmitting(false));
      errorToastMessage(err as Error);
    }
  };

export const importConsentBlocks =
  (file: File): AppThunk =>
  async (dispatch, getState) => {
    const { studyId, versionId, type, formType } = getState().consent;
    try {
      dispatch(setConsentLoader(true));
      dispatch(setConsentSubmitting(true));
      const formData = new FormData();
      formData.append("file", file);
      const prefix =
        type === "platform"
          ? `/platform/admin/econsent`
          : formType === "sunshine"
          ? `/admin/study/${studyId}/sunshine`
          : `/admin/study/${studyId}/econsent`;
      let res = await http.post(`${prefix}/import/${versionId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toastMessage("success", res?.data?.message);
      dispatch(toggleConsentLoader());
    } catch (err) {
      dispatch(setConsentSubmitting(false));
      dispatch(setConsentLoader(false));
      errorToastMessage(err as Error);
    }
  };
